<template>
    <section class="timeline">
        <div class="wrapper-timeline" v-if="hasItems">
            <div
                v-for="(timelineContent, timelineIndex) in timelineItems"
                :class="wrapperItemClass"
                :key="timelineIndex"
            >
                <div class="section-year"></div>
                <TimelineItem :items-timeline="timelineContent.items"/>
            </div>
        </div>
        <p v-else>{{ messageWhenNoItems }}</p>
    </section>
</template>

<script>
import TimelineItem from './TimelineItem.vue';
export default {
  name: 'Timeline',
  components: { TimelineItem },
  props: {
    timelineItems: {
      type: Array,
      default: () => []
    },
    messageWhenNoItems: {
      type: String
    },
    colorDots: {
      type: String,
      default: '#2da1bf'
    },
    uniqueTimeline: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasItems () {
      return !!this.timelineItems.length;
    },
    wrapperItemClass () {
      return {
        'wrapper-item': true,
        'unique-timeline': this.uniqueTimeline
      };
    }
  }
};
</script>

<style scoped>
.timeline {
  text-align: left;
  width: 100%;
  max-width: 500px;
}
.timeline .wrapper-timeline {
  position: relative;
}
.timeline .wrapper-item {
  display: grid;
  grid-template-columns: 58px 1fr;
  margin-bottom: 20px;
}
.timeline .wrapper-item .section-year {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding: 15px;
  font-weight: bold;
  font-size: 20px;
}
.timeline .wrapper-item .section-year .year {
  margin: 0;
}
.timeline .wrapper-item.unique-timeline {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Timeline/Timeline.vue